const prefix = 'nxt';
const iconName = 'toggleLargeView';
const width = 16;
const height = 16;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M14 1.5H8.54522C8.26908 1.5 8.04522 1.72386 8.04522 2V2.125H6.54522V2C6.54522 0.89543 7.44065 0 8.54522 0H14C15.1046 0 16 0.895431 16 2V7.4375C16 8.54207 15.1046 9.4375 14 9.4375H13.9881V7.9375H14C14.2761 7.9375 14.5 7.71364 14.5 7.4375V2C14.5 1.72386 14.2761 1.5 14 1.5ZM2 4.375C0.89543 4.375 0 5.27043 0 6.375V14C0 15.1046 0.89543 16 2 16H9.71972C10.8243 16 11.7197 15.1046 11.7197 14V6.375C11.7197 5.27043 10.8243 4.375 9.71972 4.375H2Z';
const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtToggleLargeView = definition;

export { definition, nxtToggleLargeView, prefix, iconName, width, height, ligatures, unicode, svgPathData };
